module.exports = __webpack_public_path__ + "img/plan4_s.07261530.svg";